import React, { FC, useEffect } from 'react';
import { useWorkPackageSubscription, useCommoditySubscription } from '@bechtel/client-work-packages';
import { useBlockSubscription } from '@bechtel/client-blocks';
import { useRodRequestSubscription, RodRequestSubscriptionContext } from '@bechtel/client-rod-room';
import { useLocation } from 'react-router-dom';
import { useCrewChangeSubscription, useCrewUpdateSubscription } from '@bechtel/client-crew-change';
import { useSyncNotificationSubscription } from '@bechtel/client-project-admin';
import { CrewChangeSubscriptionContext, useEmployeeSubscription } from '@bechtel/client-common';
import { useWeldProcedureSubscription } from '@bechtel/client-weld-common';

export const SubscriptionManager: FC<any> = ({ children }) => {
  const location = useLocation();
  useWorkPackageSubscription();
  useCommoditySubscription();
  useBlockSubscription();
  useSyncNotificationSubscription();
  useEmployeeSubscription();
  useWeldProcedureSubscription();

  const [crewChangeRequestId, setCrewChangeRequestId] = useCrewChangeSubscription();
  const [affectedCrewMembers, setAffectedCrewMembers] = useCrewUpdateSubscription();
  const [rodRequestId, setRodRequestId] = useRodRequestSubscription();

  useEffect(() => {
    const pathName = location.pathname;
    if (pathName && pathName.includes('/crew-change')) setCrewChangeRequestId('');
    if (pathName && pathName.includes('/rod-room')) setRodRequestId('');
  }, [location]);

  //Only created id's will be passed. Updates are handled in local cache call

  return (
    <RodRequestSubscriptionContext rodRequestId={rodRequestId} setRodRequestId={setRodRequestId}>
      <CrewChangeSubscriptionContext
        crewChangeRequestId={crewChangeRequestId}
        setCrewChangeRequestId={setCrewChangeRequestId}
        affectedCrewMembers={affectedCrewMembers}
        setAffectedCrewMembers={setAffectedCrewMembers}
      >
        {children}
      </CrewChangeSubscriptionContext>
    </RodRequestSubscriptionContext>
  );
};
